import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { vservice } from '@niknevis/vue-modules'
import { AdminContentCampaignService } from '@/modules/content-campaign/services/admin-content-campaign.service'

@vservice()
export class AdminContentCampaignSetToCanceledUseCase implements BaseRequestLoadingHandler {
  private isLoading = false
  private isSuccess = false

  constructor(
    private readonly service: AdminContentCampaignService
  ) {
  }

  execute(id, data): Promise<any> {
    return this.service.setToCanceled(id, data)
      .onStart(progress => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }

}